import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const TermsAndCondition = () => {

   return (<>

      {/* <ComponenetHeader
         name={'Terms & Condition'}
      /> */}

      <section className="content_page text-left">
         <div className="container">
            <div className="row content_page_style justify-content-center">
               <div className="col-xl-12 col-lg-10 col-md-10">
                  <h2 className="mb-4">Terms and Conditions</h2>
                  <p>Please carefully read these Terms and Conditions ("Terms") before accessing or using Truck Repair Shop’s website, mobile site, or applications (the "Service"). The Service is operated by Truck Repair Shop ("we," "us," "our," or "the company"). Your use of the Service constitutes acceptance of and compliance with these Terms, which apply to all visitors, users, and others accessing the Service.</p>
                  <p>By using the Service, you agree to be bound by these Terms. If you disagree with any part, you are not authorized to use the Service. We may update these Terms at any time without prior notice, and your continued use implies acceptance of the updated Terms. Changes take effect immediately upon posting.</p>

                  <h3>Service Description</h3>
                  <p>Truck Repair Shop provides online advertising and marketing services for repair facilities, roadside assistance, towing, and trucking-related services across the United States. The Service offers access to an online business directory ("Advertisers") via Truck Repair Shop’s website and applications. Users are responsible for providing internet-enabled devices and covering associated costs.</p>

                  <h3>User Accounts</h3>
                  <p>Upon registration, users receive an account and password and are responsible for all activities under their account. Unauthorized use should be reported immediately. Accounts are personal and cannot be resold or used commercially without written consent from Truck Repair Shop.</p>

                  <h3>Vendor Information Disclaimer</h3>
                  <p>Information provided by vendors or publicly sourced product data is displayed on the platform. While Truck Repair Shop strives for accuracy, we do not guarantee reliability. Users assume all risks when relying on vendor information.</p>

                  <h4>Service Changes and Interruptions</h4>
                  <p>Truck Repair Shop may modify or discontinue the Service at any time without notice. We are not liable for interruptions or operational challenges beyond our control.</p>

                  <h4>Privacy</h4>
                  <p>Use of the Service is governed by Truck Repair Shop’s Privacy Policy. Third-party websites linked from our platform are subject to their own terms and privacy policies. We are not responsible for third-party content or availability.</p>

                  <h4>Prohibited Activities</h4>
                  <p>All use of Truck Repair Shop Services must comply with these Terms. Unauthorized activities such as copying content, competing with Truck Repair Shop, or engaging in fraudulent or harmful actions are strictly prohibited. Violations may result in account termination and legal action.</p>

                  <h4>User Information</h4>
                  <p>By using the Service, you may provide personal information, which may be shared with Advertisers to fulfill your requests. By submitting information, you consent to being contacted by Truck Repair Shop and its partners via SMS, email, or other channels. Users must provide accurate information and update it as needed. False information may result in penalties or legal action.</p>

                  <h5>Intellectual Property</h5>
                  <p>All content and software on the platform are owned by Truck Repair Shop and protected under intellectual property laws. Unauthorized use, modification, or distribution is prohibited. Trademarks on the platform belong to their respective owners.</p>

                  <h5>Copyright Infringement Notification</h5>
                  <p>Claims of copyright infringement can be reported to Truck Repair Shop via:</p>
                  <ul>
                     <li><strong>Phone:</strong> +1 (800) 805-7820</li>
                     <li><strong>Email:</strong> contact@truckrepairshop.net</li>
                  </ul>

                  <h5>Legal Compliance</h5>
                  <p>Users must comply with all applicable local, state, and federal laws when using the Service. Actions encouraging illegal behavior are prohibited.</p>

                  <h5>Warranties Disclaimer</h5>
                  <p>Truck Repair Shop provides the Service "as is," without any warranties, including those regarding Advertisers, accuracy, or reliability. We are not liable for damages from the use or inability to use the Service.</p>

                  <h5>Limitation of Liability</h5>
                  <p>Truck Repair Shop is not responsible for direct, indirect, or incidental damages arising from use of the platform. Some jurisdictions may not allow this limitation, so it may not apply to all users.</p>

                  <h6>Indemnification</h6>
                  <p>Users agree to indemnify Truck Repair Shop, its affiliates, and partners against claims arising from their use of the Service or violation of these Terms.</p>

                  <h6>General Terms</h6>
                  <p>These Terms are governed by Illinois law, and disputes will be resolved in DuPage County, Illinois. Claims must be filed within one year of occurrence. If any provision is unenforceable, the remaining Terms remain in effect.</p>

                  <h6>Points System</h6>

                  <p className="mb-1"><strong>Earning Points</strong></p>
                  <ul>
                     <li>Users earn points by uploading service bills, including truck repair services and other eligible invoices on the platform.</li>
                     <li>Every 100 Coins earned equals $10 in rewards.</li>
                  </ul>

                  <p className="mb-1"><strong>Redeeming Points</strong></p>
                  <ul>
                     <li>Users can redeem points once they reach a minimum balance of $100 (1,000 Coins).</li>
                     <li>Redeemed rewards are credited to the user's account using the available platform payment method.</li>
                  </ul>

                  <p className="mb-1"><strong>Minimum Balance Requirement</strong></p>
                  <ul>
                     <li>Users must maintain a minimum balance of $10 (100 Coins) in their account.</li>
                     <li>Redemption requests that drop the balance below $10 will not be processed.</li>
                  </ul>

                  <p className="mb-1"><strong>Fraud & Abuse</strong></p>
                  <ul>
                     <li>Fraudulent activities, such as manipulating the points system or uploading fake bills, will lead to immediate account suspension and forfeiture of points.</li>
                  </ul>

                  <p className="mb-1"><strong>Modification of Terms</strong></p>
                  <ul>
                     <li>The platform reserves the right to modify or discontinue the points system at any time without notice. Users should review this section regularly for updates.</li>
                  </ul>

                  <p className="mb-1"><strong>Disputes & Final Decision</strong></p>
                  <ul>
                     <li>Any disputes regarding point earning or redemption will be resolved at the sole discretion of the platform administration.</li>
                  </ul>


               </div>

            </div>
         </div>
      </section>
   </>
   );
};

export default TermsAndCondition;